import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {ConstantProvider} from '../../../../../_services/constants.service';
import {LocalStorageService} from '../../../../../_services';

@Component({
  selector: 'app-why-choose-emotion',
  templateUrl: './choose-emotion.component.html',
  styleUrls: ['./choose-emotion.component.scss'],
})
export class ChooseEmotionComponent implements OnInit {

  @Input() parentEmotions = [];
  @Input() maxEmotions;
  @Input() fromMapFilter = false;
  @Input() fromFilter = false;
  @Input() viewOnly = false;
  @Input() addReport = true;
  selectedEmotions = [];
  emotions: any;
  selectedPalette = 'orange';
  selectedProjectObj: any;

  constructor(public constants: ConstantProvider,
              private localStorage: LocalStorageService,
              public translate: TranslateService, public modalController: ModalController) {
    this.selectedProjectObj = this.localStorage.get('selected_project');
  }

  ngOnInit() {
    let projectType = localStorage.getItem('projectType');
    console.log(this.selectedProjectObj, 'projectType');
    if (projectType === null) {
      localStorage.setItem('projectType', 'act');
      projectType = 'act';
    }
    this.selectedEmotions = Object.assign([], this.parentEmotions);
    if (projectType !== 'ap') {
      this.emotions = this.selectedProjectObj.mappedEmotions;
      // this.emotions = this.constants.emotions.filter((emotionObj: any) => emotionObj.project.indexOf(projectType) > -1);
    } else {
      this.emotions = this.constants.emotions;
    }
  }

  selectPalette(palette: string, emotion: string) {
    console.log(emotion, palette);
    const selectedPaletteElement = window.document.querySelectorAll('.emotion-palette');
    selectedPaletteElement.forEach(elem => elem.classList.remove('selected'));
    const paletteElement = window.document.querySelector('#palette-' + palette) as HTMLElement;
    paletteElement.classList.add('selected');
    this.selectedPalette = palette;
    const emotionDiv = window.document.querySelector('#emotion-wrapper-' + emotion) as HTMLInputElement;
    emotionDiv.scrollIntoView({
      behavior: 'smooth'
    });
  }

  getSelectedEmotions() {
    return Array.prototype.map.call(this.selectedEmotions, (item) => item.name).join(', ');

  }

  isEmotionSelected(emotion) {
    return this.selectedEmotions.some(emotionObj => emotionObj.name === emotion.name);
  }

  selectEmotion(emotion) {
    if (!this.fromMapFilter) {
      const present = this.isEmotionSelected(emotion);
      if (present) {
        return;
      }
      if (this.fromMapFilter || this.fromFilter || this.selectedEmotions.length < this.maxEmotions) {
        if (!present) {
          this.selectedEmotions.push(emotion);
        }
      }
    }
  }

  deSelectEmotion(event, emotion) {
    event.stopPropagation();
    const present = this.isEmotionSelected(emotion);
    if (present) {
      this.selectedEmotions = this.selectedEmotions.filter(emotionObj => emotionObj.name !== emotion.name);
    }
  }

  confirmSelection() {
    if (this.selectedEmotions.length > 0) {
      this.modalController.dismiss(this.selectedEmotions);
    } else {
      this.modalController.dismiss();
    }
  }

  dismiss(): void {
    if (this.fromMapFilter) {
      this.confirmSelection();
    } else {
      this.modalController.dismiss();
    }
  }

  gotToTop() {
    const myDiv = window.document.querySelector('#emotion-content') as HTMLInputElement;
    myDiv.scroll({top: 0, behavior: 'smooth'});
  }
}
